// The words the production board uses for the things a plant builds and waits
// on. The board grew up at Holman, where a job is a truck, the thing a job
// waits on is its chassis and the source system is Treqso; the locale strings
// carry those as interpolation variables ({{unit}}, {{material}}, {{source}} …)
// so another company reads its own words. Pure data: no i18n import here, so
// src/i18n.ts can seed the defaults without a cycle.
export interface Vocabulary {
	/** one job as the customer counts it: truck, lot, job */
	unit: string;
	units: string;
	Unit: string;
	Units: string;
	/** what a job waits on before it can start: chassis, castings, material */
	material: string;
	Material: string;
	MATERIAL: string;
	/** the system of record the job book comes from */
	source: string;
	/** a board site: profit centre, cell, site */
	site: string;
	sites: string;
	Site: string;
	Sites: string;
	/** the crew label on a job */
	Team: string;
}

export const GENERIC_VOCABULARY: Vocabulary = {
	unit: "job", units: "jobs", Unit: "Job", Units: "Jobs",
	material: "material", Material: "Material", MATERIAL: "MATERIAL",
	source: "the ERP",
	site: "site", sites: "sites", Site: "Site", Sites: "Sites",
	Team: "Team",
};

export const HOLMAN_VOCABULARY: Vocabulary = {
	unit: "truck", units: "trucks", Unit: "Truck", Units: "Trucks",
	material: "chassis", Material: "Chassis", MATERIAL: "CHASSIS",
	source: "Treqso",
	site: "profit centre", sites: "profit centres", Site: "Profit centre", Sites: "Profit centres",
	Team: "Mechanic team",
};

export const NXEDGE_VOCABULARY: Vocabulary = {
	unit: "lot", units: "lots", Unit: "Lot", Units: "Lots",
	material: "castings", Material: "Castings", MATERIAL: "CASTINGS",
	source: "Epicor",
	site: "cell", sites: "cells", Site: "Cell", Sites: "Cells",
	Team: "Cell crew",
};

/** Companies with their own words; everyone else gets the generic set. */
export const VOCABULARY_BY_COMPANY: Record<number, Vocabulary> = {
	46: HOLMAN_VOCABULARY,
	226: NXEDGE_VOCABULARY,
};

export const vocabularyFor = (companyId: number | string | null | undefined): Vocabulary =>
	VOCABULARY_BY_COMPANY[Number(companyId)] ?? GENERIC_VOCABULARY;
